<div class="card-page-wrapper">
    <app-card-page
        [cardPage]="cardPage"
    ></app-card-page>
</div>
